import { components } from 'react-select/dist/react-select.cjs.prod';
import AuthorizedComponent from '../components/hoc/AuthorizedComponent';
import {
  AddEvents,
  AddOffer,
  AddTerminal,
  ContactUs,
  Dashboard,
  ViewEarnings,
  ViewEvents,
  ViewOffers,
  ViewPayments,
  ViewTerminals,
  AddPayment,
  AddMerchant,
  Home,
  ViewMerchants,
  AddMerchantGroups,
  ViewMerchantGroups,
  ViewPurchases,
  PendingPurchases,
  ViewVouchers,
  AddProducts,
  OTPLogs,
  IPLogs,
  DenominationsSummary,
  UploadDenominations,
  ViewClientOrders,
  PlaceClientOrder,
  ViewOrders,
  ViewVoucherThemes,
  ViewProducts,
  AddVoucherThemes,
  ManageRatios,
  WorkInProgress,
  AddEventConditions,
  ViewEventConditions,
  AddUsers,
  AccountStatusManagement,
  AddTiers,
  ViewTiers,
  ManageRewardRules,
  AddRewardRule,
  ViewMccCodes,
  AddMccCode,
  AuditLogs,
  SmsTemplates,
  FailedBatchRecords,
  ManageRolePermissions,
  CreateRole,
  ViewRoles,
  DashboardAnalytics,
  PopularMerchants,
} from '../screens';
import PendingCreditTopUp from '../screens/PendingCreditTopUp/PendingCreditTopUp';
import UserDetails from '../screens/userDetails/userDetails.screen';
import ViewUsers from '../screens/userManagement/userManagement.screen';
import ViewExecutionLogScreen from '../screens/viewExecutionLog/ViewExecutionLog.screen';
import { EarningsRoles } from '../types/RedemptionEnums';
import {
  DASHBOARD_ANALYTICS_PERMISSIONS,
  POINT_ACCOUNT_PERMISSIONS,
  EARNINGS_PERMISSIONS,
  ROLE_MANAGEMENT_PERMISSIONS,
  USER_MANAGEMENT_PERMISSIONS,
  TIER_MANAGEMENT_PERMISSIONS,
  SECURITY_LOGS_PERMISSIONS,
  MCC_MANAGEMENT_PERMISSIONS,
  REWARD_RULE_MANAGEMENT_PERMISSIONS,
  AUDIT_LOG_PERMISSIONS,
  SMS_PERMISSIONS,
  FAILED_BATCH_PERMISSIONS,
} from '../constants/permissions';

export const acceptOfferRole = ['ROLE_THYAGA_ADMINISTRATOR'];

// const acceptTerminalsRole = [
//   'ROLE_THYAGA_ADMINISTRATOR',
//   'ROLE_LOYALTY_SUPER_ADMIN',
//   'ROLE_THYAGA_MERCHANT_CONTROLLER',
//   'ROLE_THYAGA_CUSTOMER_CARE',
// ];

// const acceptEarningsRole = Object.values(EarningsRoles);

// const acceptAddMerchantRole = [
//   'ROLE_THYAGA_ADMINISTRATOR',
//   'ROLE_THYAGA_CUSTOMER_CARE',
//   'ROLE_THYAGA_MERCHANT_CONTROLLER',
//   'ROLE_THYAGA_ACCOUNTANT',
// ];

// const acceptPaymentsRole = ['ROLE_MERCHANT_ADMINISTRATOR'];

// const acceptAddPaymentRole = [
//   'ROLE_THYAGA_ADMINISTRATOR',
//   'ROLE_THYAGA_ACCOUNTANT',
// ];

// const acceptViewPurchases = [
//   'ROLE_THYAGA_ADMINISTRATOR',
//   'ROLE_THYAGA_CUSTOMER_CARE',
//   'ROLE_THYAGA_ACCOUNTANT',
// ];
// const acceptUserDetails = ['ROLE_THYAGA_ADMINISTRATOR'];

// const acceptViewVouchers = [
//   'ROLE_THYAGA_ADMINISTRATOR',
//   'ROLE_THYAGA_CUSTOMER_CARE',
//   'ROLE_THYAGA_ACCOUNTANT',
// ];

// const acceptUserLogs = [
//   'ROLE_THYAGA_ADMINISTRATOR',
//   'ROLE_LOYALTY_SUPER_ADMIN',
//   'ROLE_THYAGA_CUSTOMER_CARE',
// ];

// const acceptDemoScreens = ['ROLE_THYAGA_DEMO'];


const routes = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    acceptPermissions: [DASHBOARD_ANALYTICS_PERMISSIONS.DASHBOARD_ANALYTICS.VIEW],
    component: AuthorizedComponent(DashboardAnalytics, [
      DASHBOARD_ANALYTICS_PERMISSIONS.DASHBOARD_ANALYTICS.VIEW,
    ]),
  },
  {
    name: 'Point Account',
    path: '/',
    acceptPermissions: [POINT_ACCOUNT_PERMISSIONS.POINT_ACCOUNT.VIEW],
    component: AuthorizedComponent(ViewVouchers, [POINT_ACCOUNT_PERMISSIONS.POINT_ACCOUNT.VIEW]),
  },
  {
    name: 'Earnings',
    path: '/earnings',
    acceptPermissions: [EARNINGS_PERMISSIONS.VIEW_REDEMPTIONS.VIEW],
    children: [
      {
        name: 'View Redemptions',
        path: '',
        acceptPermissions: [EARNINGS_PERMISSIONS.VIEW_REDEMPTIONS.VIEW],
        component: AuthorizedComponent(ViewEarnings, [
          EARNINGS_PERMISSIONS.VIEW_REDEMPTIONS.VIEW,
        ]),
      },
      {
        name: 'Popular Merchants',
        path: '/popular-merchants',
        acceptPermissions: [EARNINGS_PERMISSIONS.POPULAR_MERCHANTS.VIEW],
        component: AuthorizedComponent(PopularMerchants, [
          EARNINGS_PERMISSIONS.POPULAR_MERCHANTS.VIEW,
        ]),
      },
    ],
  },
  {
    name: 'Security Logs',
    path: '/security',
    children: [
      {
        name: 'IP Logs',
        path: '/ip-logs',
        acceptPermissions: [SECURITY_LOGS_PERMISSIONS.IP_LOGS.VIEW],
        component: AuthorizedComponent(IPLogs, [SECURITY_LOGS_PERMISSIONS.IP_LOGS.VIEW]),
      },
      {
        name: 'OTP Logs',
        path: '/otp-logs',
        acceptPermissions: [SECURITY_LOGS_PERMISSIONS.OTP_LOGS.VIEW],
        component: AuthorizedComponent(OTPLogs, [SECURITY_LOGS_PERMISSIONS.OTP_LOGS.VIEW]),
      },
    ],
  },
  {
    name: 'Role Management',
    path: '/role-management',
    children: [
      {
        name: 'Create Role',
        path: '/create-role',
        acceptPermissions: [ROLE_MANAGEMENT_PERMISSIONS.CREATE_ROLE.VIEW],
        component: AuthorizedComponent(CreateRole, [
          ROLE_MANAGEMENT_PERMISSIONS.CREATE_ROLE.VIEW,
        ]),
      },
      {
        name: 'View Roles',
        path: '/view-roles',
        acceptPermissions: [ROLE_MANAGEMENT_PERMISSIONS.VIEW_ROLES.VIEW],
        component: AuthorizedComponent(ViewRoles, [
          ROLE_MANAGEMENT_PERMISSIONS.VIEW_ROLES.VIEW,
        ]),
      },
      {
        name: 'Roles & Permissions',
        path: '/role-permissions',
        acceptPermissions: [ROLE_MANAGEMENT_PERMISSIONS.ROLE_PERMISSIONS.VIEW],
        component: AuthorizedComponent(ManageRolePermissions, [
          ROLE_MANAGEMENT_PERMISSIONS.ROLE_PERMISSIONS.VIEW,
        ]),
      }

    ],
  },
  {
    name: 'User Management',
    path: '/user-management',
    children: [
      {
        name: 'View Users',
        path: '/view-users',
        acceptPermissions: [USER_MANAGEMENT_PERMISSIONS.VIEW_USERS.VIEW],
        component: AuthorizedComponent(ViewUsers, [USER_MANAGEMENT_PERMISSIONS.VIEW_USERS.VIEW]),
      },
      {
        name: 'Add Users',
        path: '/add-users',
        acceptPermissions: [USER_MANAGEMENT_PERMISSIONS.ADD_USERS.CREATE],
        component: AuthorizedComponent(AddUsers, [USER_MANAGEMENT_PERMISSIONS.ADD_USERS.CREATE]),
      },
      {
        name: 'View Customers Details',
        path: '/view-customer-details',
        acceptPermissions: [USER_MANAGEMENT_PERMISSIONS.VIEW_CUSTOMERS.VIEW],
        component: AuthorizedComponent(AccountStatusManagement, [
          USER_MANAGEMENT_PERMISSIONS.VIEW_CUSTOMERS.VIEW,
        ]),
      },
    ],
  },
  {
    name: 'Tier Management',
    path: '/tiers',
    children: [
      {
        name: 'View Tiers',
        path: '/view-tiers',
        acceptPermissions: [TIER_MANAGEMENT_PERMISSIONS.VIEW_TIERS.VIEW],
        component: AuthorizedComponent(ViewTiers, [TIER_MANAGEMENT_PERMISSIONS.VIEW_TIERS.VIEW]),
      },
      {
        name: 'Add Tier',
        path: '/add-tier',
        acceptPermissions: [TIER_MANAGEMENT_PERMISSIONS.ADD_TIER.CREATE],
        component: AuthorizedComponent(AddTiers, [TIER_MANAGEMENT_PERMISSIONS.ADD_TIER.CREATE]),
      },
    ],
  },
    {
    name: 'MCC Code Management',
    path: '/mcc-codes',
    children: [
      {
        name: 'View MCC Codes',
        path: '/view-mcc-codes',
        acceptPermissions: [MCC_MANAGEMENT_PERMISSIONS.VIEW_MCC_CODES.VIEW],
        component: AuthorizedComponent(ViewMccCodes, [MCC_MANAGEMENT_PERMISSIONS.VIEW_MCC_CODES.VIEW]),
      },
      {
        name: 'Add MCC Code',
        path: '/add-mcc-code',
        acceptPermissions: [MCC_MANAGEMENT_PERMISSIONS.ADD_MCC_CODE.CREATE],
        component: AuthorizedComponent(AddMccCode, [MCC_MANAGEMENT_PERMISSIONS.ADD_MCC_CODE.CREATE]),
      },
    ],
  },
  {
    name: 'Reward Rule Management',
    path: '/reward-rules',
    children: [
      {
        name: 'Manage Rules',
        path: '',
        acceptPermissions: [REWARD_RULE_MANAGEMENT_PERMISSIONS.MANAGE_RULES.VIEW],
        component: AuthorizedComponent(ManageRewardRules, [
          REWARD_RULE_MANAGEMENT_PERMISSIONS.MANAGE_RULES.VIEW,
        ]),
      },
      {
        name: 'Add Rule',
        path: '/add',
        acceptPermissions: [REWARD_RULE_MANAGEMENT_PERMISSIONS.ADD_RULE.CREATE],
        component: AuthorizedComponent(AddRewardRule, [
          REWARD_RULE_MANAGEMENT_PERMISSIONS.ADD_RULE.CREATE,
        ]),
      },
    ],
  },
  {
    name: 'Audit Log Management',
    path: '/audit-logs',
    children: [
      {
        name: 'Audit Logs',
        path: '',
        acceptPermissions: [AUDIT_LOG_PERMISSIONS.AUDIT_LOGS.VIEW],
        component: AuthorizedComponent(AuditLogs, [AUDIT_LOG_PERMISSIONS.AUDIT_LOGS.VIEW]),
      }
    ],
  },
 {
  name: 'SMS & Communication',
  path: '/sms-communication',
  children: [
    {
      name: 'SMS Templates',
      path: '',
      acceptPermissions: [SMS_PERMISSIONS.SMS_TEMPLATES.VIEW],
      component: AuthorizedComponent(SmsTemplates, [SMS_PERMISSIONS.SMS_TEMPLATES.VIEW]),
    }
  ],
},
 {
  name: 'Failed Batch Records',
  path: '/failedBatchRecords',
  children: [
    {
      name: 'Failed Records',
      path: '',
      acceptPermissions: [FAILED_BATCH_PERMISSIONS.FAILED_RECORDS.VIEW],
      component: AuthorizedComponent(FailedBatchRecords, [
        FAILED_BATCH_PERMISSIONS.FAILED_RECORDS.VIEW,
      ]),
    }
  ],
},






  // {
  //   name: 'Home',
  //   path: '/',
  //   component: Home,
  // },
  // {
  //   name: 'User Details',
  //   path: '/user-details',
  //   acceptUserRole: acceptUserDetails,
  //   component: AuthorizedComponent(UserDetails, acceptUserDetails),
  // },
  // {
  //   name: 'Home',
  //   path: '/',
  //   component: Home,
  // },
  // {
  //   name: 'Loyalty Accounts',
  //   path: '/',
  //   component: AuthorizedComponent(ViewVouchers, acceptDemoScreens),
  // },
  // {
  //   name: 'Extras',
  //   path: '/extras',
  //   acceptUserRole: acceptOfferRole,
  //   children: [
  //     {
  //       name: 'Awards',
  //       path: '/awards',
  //       component: AuthorizedComponent(WorkInProgress, acceptDemoScreens),
  //     },
  //     {
  //       name: 'Campaigns',
  //       path: '/campaigns',
  //       component: AuthorizedComponent(WorkInProgress, acceptDemoScreens),
  //     },
  //   ],
  // },
  // {
  //   name: 'Reward Catalog',
  //   path: '/catalog',
  //   acceptUserRole: acceptDemoScreens,
  //   children: [
  //     {
  //       name: 'View Merchants',
  //       path: '/view-Merchants',
  //       component: AuthorizedComponent(ViewMerchants, acceptDemoScreens),
  //     },
  //     {
  //       name: 'Add Merchant Codes',
  //       path: '/add-merchant-codes',
  //       component: AuthorizedComponent(UploadDenominations, acceptDemoScreens),
  //     },
  //     {
  //       name: 'Gift Inventory',
  //       path: '/gift-inventory',
  //       component: AuthorizedComponent(DenominationsSummary, acceptDemoScreens),
  //     },
  //     {
  //       name: 'View Offers',
  //       path: '/',
  //       component: AuthorizedComponent(ViewOffers, acceptDemoScreens),
  //     },
  //     {
  //       name: 'Add Offer',
  //       path: '/add-offer',
  //       component: AuthorizedComponent(AddOffer, acceptDemoScreens),
  //     },
  //     // {
  //     //   name: 'Add Merchant',
  //     //   path: '/add-Merchant',
  //     //   component: AuthorizedComponent(AddMerchant, acceptDemoScreens),
  //     // },
  //   ],
  // },
  // {
  //   name: 'Reward Management',
  //   path: '/',
  //   acceptUserRole: acceptDemoScreens,
  //   children: [
  //     {
  //       name: 'Manage Tiers',
  //       path: '/reward-management/manage-tiers',
  //       component: AuthorizedComponent(ManageRatios, acceptDemoScreens),
  //     },
  //     // {
  //     //   name: 'Loyalty Accounts',
  //     //   path: '/reward-management/accounts',
  //     //   component: AuthorizedComponent(ViewVouchers, acceptDemoScreens),
  //     // },
  //   ],
  // },
  // {
  //   name: 'User Management',
  //   path: '/user-management',
  //   acceptUserRole: acceptDemoScreens,
  //   children: [
  //     {
  //       name: 'View Users',
  //       path: '/view-users',
  //       component: AuthorizedComponent(UserDetails, acceptDemoScreens),
  //     },
  //   ],
  // },
  // {
  //   name: 'Redemptions',
  //   path: '/redemptions',
  //   acceptUserRole: acceptDemoScreens,
  //   children: [
  //     {
  //       name: 'View Redemptions',
  //       path: '/view-redemptions',
  //       component: AuthorizedComponent(ViewEarnings, acceptDemoScreens),
  //     },
  //   ],
  // },
  // {
  //   name: 'Events',
  //   path: '/events',
  //   acceptUserRole: acceptDemoScreens,
  //   children: [
  //     {
  //       name: 'View Events',
  //       path: '/',
  //       component: AuthorizedComponent(ViewEvents, acceptDemoScreens),
  //     },
  //     {
  //       name: 'Add Events',
  //       path: '/add-events',
  //       component: AuthorizedComponent(AddEvents, acceptDemoScreens),
  //     },
  //     {
  //       name: 'View Execution Logs ',
  //       path: '/view-execution-logs',
  //       component: AuthorizedComponent(
  //         ViewExecutionLogScreen,
  //         acceptDemoScreens
  //       ),
  //     },
  //   ],
  // },
  // {
  //   name: 'Event Conditions',
  //   path: '/event-conditions',
  //   acceptUserRole: acceptDemoScreens,
  //   children: [
  //     {
  //       name: 'View Event Conditions',
  //       path: '/',
  //       component: AuthorizedComponent(ViewEventConditions, acceptDemoScreens),
  //     },
  //     {
  //       name: 'Add Event Conditions',
  //       path: '/add-event-conditions',
  //       component: AuthorizedComponent(AddEventConditions, acceptDemoScreens),
  //     },
  //   ],
  // },
  // {
  //   name: 'Security Logs',
  //   path: '/security',
  //   acceptUserRole: acceptDemoScreens,
  //   children: [
  //     {
  //       name: 'IP Logs',
  //       path: '/',
  //       component: AuthorizedComponent(IPLogs, acceptDemoScreens),
  //     },
  //   ],
  // },
  // {
  //   name: 'Offers',
  //   path: '/offers',
  //   acceptUserRole: acceptOfferRole,
  //   children: [
  //     {
  //       name: 'View Offers',
  //       path: '/',
  //       component: AuthorizedComponent(ViewOffers, acceptOfferRole),
  //     },
  //     {
  //       name: 'Add Offer',
  //       path: '/add-offer',
  //       component: AuthorizedComponent(AddOffer, acceptOfferRole),
  //     },
  //   ],
  // },
  // {
  //   name: 'Terminals',
  //   path: '/terminals',
  //   acceptUserRole: acceptTerminalsRole,
  //   children: [
  //     {
  //       name: 'View Terminals',
  //       path: '',
  //       component: AuthorizedComponent(ViewTerminals, acceptTerminalsRole),
  //     },
  //     {
  //       name: 'Add Terminal',
  //       path: '/add-terminal',
  //       component: AuthorizedComponent(AddTerminal, acceptTerminalsRole),
  //     },
  //   ],
  // },
  // {
  //   name: 'Payments',
  //   path: '/payments',
  //   acceptUserRole: acceptPaymentsRole,
  //   children: [
  //     {
  //       name: 'View Payments',
  //       path: '',
  //       component: AuthorizedComponent(ViewPayments, acceptPaymentsRole),
  //     },
  //   ],
  // },
  // {
  //   name: 'Payments',
  //   path: '/payments',
  //   acceptUserRole: acceptAddPaymentRole,
  //   children: [
  //     {
  //       name: 'View Payments',
  //       path: '/payments',
  //       component: AuthorizedComponent(ViewPayments, acceptAddPaymentRole),
  //     },
  //     {
  //       name: 'Add Payment',
  //       path: '/add-payment',
  //       component: AuthorizedComponent(AddPayment, acceptAddPaymentRole),
  //     },
  //   ],
  // },
  // {
  //   name: 'Purchases',
  //   path: '/purchases',
  //   acceptUserRole: acceptViewPurchases,
  //   children: [
  //     {
  //       name: 'View Purchases',
  //       path: '/view-Purchases',
  //       component: AuthorizedComponent(ViewPurchases, acceptViewPurchases),
  //     },
  //     {
  //       name: 'Pending Purchases',
  //       path: '/pending-Purchases',
  //       component: AuthorizedComponent(PendingPurchases, acceptViewPurchases),
  //     },
  //   ],
  // },
  // {
  //   name: 'Contact Us',
  //   path: '/contact-us',
  //   component: ContactUs,
  // },
];

export default routes;
